// src/js/main.js

// --- Sistema de Contenido (Pexels + Fallback) ---
//import { initContenido } from '../modules/contenido/contenidoLoadMain.js';

// --- Sistema de Usuarios (Login + Register) ---
//import { initRegisterBlock } from '../modules/usersLoginRegister/usersRegisterBlock.js';
//import { initLoginBlock } from '../modules/usersLoginRegister/usersLoginBlock.js';
//import { initModalHandlers } from '../modules/usersLoginRegister/modalHandlers.js';

// --- Utilidades Globales ---

// document.addEventListener('DOMContentLoaded', () => {
//   initJubesaParticles();
// });

import '../modules/nav__module/nav__module.js';
//import '../modules/nav__module/subrayadoEfectoSaliente.js'; //Activar para Efecto de Hover Subrayado Saliente en opciones de NAV
import '../modules/gotop/gotop.jubesa.js';
//import './utils/abrirmodal.js';
import './utils/scroll-footer.js';

//import './utils/cursorHalo.js';
import './utils/pulse.js';

//import './identidad/identidad-ceremonial.js';

import './reset/resetButton.js';
//import '../modules/calificationStarsSystem/calificationStarsSystem.js';
import '../modules/typography-panel/typography-panel.js';

// --- Inicialización Global ---
document.addEventListener('DOMContentLoaded', () => {
  // Contenido dinámico
  //initContenido();

  // Usuarios
  //initRegisterBlock();
  //initLoginBlock();
  //initModalHandlers();

  console.log('Jubesa inicializado con pureza modular ✨');
});
console.log('Webhook Aplicado con Éxito 🚀');
